import { render, staticRenderFns } from "./warning-item.vue?vue&type=template&id=4cd6fcfb&"
import script from "./warning-item.vue?vue&type=script&lang=js&"
export * from "./warning-item.vue?vue&type=script&lang=js&"
import style0 from "./warning-item.vue?vue&type=style&index=0&id=4cd6fcfb&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports